import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CollectionsService } from '../../../collections/service/collections.service';
import { DataService } from '../../../../core/services/data.service';
import { AuthService } from '../../../../core/services/auth.service';
import { NativeIntegrationService } from '../../../../core/services/native-integration.service';
import { BridgeMode } from '@hg-com/xwc-js-bridge/dist/native-app.service';
import {
  IProgressInfo,
  ProgressStatus,
} from '@hg-com/xwc-js-bridge/dist/modules';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-pack-download',
  templateUrl: './pack-download.component.html',
  styleUrls: ['./pack-download.component.scss'],
})
export class PackDownloadComponent implements OnInit {
  dataPackProgress: number | undefined = 0;
  dataPackUpdate = '';
  dataList?: any;
  mediaList?: any;
  downloadInfo?: IProgressInfo;
  dataPackDownloadStarted = false;
  private subscriptions: Subscription = new Subscription();

  constructor(
    private router: Router,
    private collectionsService: CollectionsService,
    private nis: NativeIntegrationService,
    private dataService: DataService,
    private authService: AuthService,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    console.log('[PACK DOWNLOAD]: Init');
    this.nis.spinTillReady().then(() => {
      if (this.nis.isNative$.getValue()) {
        console.log('[PACK DOWNLOAD]: in native Context');
        this.contentPackList();
      } else {
        console.log('[PACK DOWNLOAD]: in online Context');
        this.initData('online');
      }
    });

    window.onbeforeunload = () => this.abortDownloads();
  }

  initData(mode: string): void {
    // this.dataService.offlineMode$.next(false);
    if (mode === 'online') {
      this.nis.offlineMode$.next(false);
    }
    if (this.dataService.translationsLoaded$.getValue()) {
      console.log('[PACK DOWNLOAD]: Translations loaded - > TRUE');
      console.log('[PACK DOWNLOAD]>[ROUTER]: Navigate Home');
      setTimeout(() => {
        const origin = this.route.snapshot.queryParamMap.get('origin');
        if (origin) {
          this.router.navigateByUrl(origin).then();
        } else {
          this.router.navigate(['/home']).then();
        }
      }, 500);
      return;
    } else {
      console.log('[PACK DOWNLOAD]: Translation Subscription');
      // toDo: Check all calls completed
      const translationSub = this.dataService.translationsLoaded$.subscribe(
        (loaded) => {
          console.log(
            '[PACK DOWNLOAD]: Translation Subscription Value:' + loaded
          );
          if (loaded) {
            console.log(
              '[PACK DOWNLOAD]>[ROUTER]: Translation Subscription ->  Navigate Home'
            );
            setTimeout(() => {
              const origin = this.route.snapshot.queryParamMap.get('origin');
              if (origin) {
                this.router.navigateByUrl(origin).then();
              } else {
                this.router.navigate(['/home']).then();
              }
            }, 500);
          }
        }
      );
      this.subscriptions.add(translationSub);
    }
  }

  initOfflineData(): void {
    console.log('[PACK DOWNLOAD]: Init Offline Mode ');
    this.dataService.urlParamFile = '';
    this.dataService.urlParamContext = '';
    this.dataService.apiUrl = `http://localhost:${this.nis.native.port}/xwc/pack/latest/data`;
    this.nis.offlineMode$.next(true);
    this.initData('offline');
    // this.router.navigate(['/home']).then();
  }

  contentPackList(): void {
    console.log('[PACK DOWNLOAD]: Get content pack list');
    this.dataPackUpdate = 'checking-data';
    this.nis.contentPack
      .list$()
      .then((list) => {
        console.log('[PACK DOWNLOAD]: Success content pack list');
        console.log(list);
        this.dataList = Object.values(
          list.data.filter((ob: { packId: string }) => ob.packId === 'data')
        );
        this.mediaList = Object.values(
          list.data.filter((ob: { packId: string }) => ob.packId === 'media')
        );

        // Subscribe to progress AFTER we have the list and know what to download
        // This prevents race conditions with iOS background task progress events
        this.subscribeToProgress();

        if (
          (this.dataList[0] && this.dataList[0].__loaded === null) ||
          this.dataList[0].__loaded.updateAvailable
        ) {
          console.log('[PACK DOWNLOAD]: Update data pack');
          this.updateDataPack();
        } else if (
          (this.mediaList[0] && this.mediaList[0].__loaded === null) ||
          this.mediaList[0].__loaded.updateAvailable
        ) {
          console.log('[PACK DOWNLOAD]: Update media pack');
          this.updateMediaPack();
        } else {
          console.log('[PACK DOWNLOAD]: No updates available');
          this.initOfflineData();
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }

  private subscribeToProgress(): void {
    console.log('[PACK DOWNLOAD]: Subscribe contentPackDownloadProgress');
    const progressSub =
      this.nis.contentPack.contentPackDownloadProgress.subscribe((res) => {
        console.log('[PACK DOWNLOAD]: Progress Task token: ' + res.taskToken);
        if (res.progress && res.size) {
          this.dataPackProgress = Number(
            ((res.progress / res.size) * 100).toFixed(0)
          );
          console.log('[PACK DOWNLOAD]: Progress: ' + this.dataPackProgress);
          console.log(res);
        }

        if (res.status === ProgressStatus.Finished) {
          console.log('Finished or 100%', res);
          if (this.dataPackUpdate === 'downloading-data') {
            console.log('Data done');
            if (
              (this.mediaList[0] && this.mediaList[0].__loaded === null) ||
              this.mediaList[0].__loaded.updateAvailable
            ) {
              console.log(
                '[PACK DOWNLOAD]: Updated data pack, check media pack'
              );
              this.dataPackProgress = 0;
              this.dataPackDownloadStarted = false;
              this.dataPackUpdate = 'checking-media';
              this.updateMediaPack();
            } else {
              setTimeout(() => this.initOfflineData(), 500);
            }
          } else if (this.dataPackUpdate === 'downloading-media') {
            console.log('[PACK DOWNLOAD]: Updated media pack');
            setTimeout(() => this.initOfflineData(), 500);
          } else {
            console.warn(
              '[PACK DOWNLOAD]: Received Finished status in unexpected state:',
              this.dataPackUpdate
            );
          }
        }
      });
    this.subscriptions.add(progressSub);
  }

  updateDataPack() {
    this.dataPackUpdate = 'downloading-data';
    this.dataPackDownloadStarted = true;
    console.log('[PACK DOWNLOAD]: In Func Update Data Pack');
    return this.nis.contentPack
      .updatePack$(this.dataList[0].mediaId, this.dataList[0].packId)
      .then((res) => {
        console.log('[PACK DOWNLOAD]: Response updatePack$ Data Success');
        if (res.data) {
          console.log('[PACK DOWNLOAD]: Response updatePack$ Success');
          console.log(res);
          this.downloadInfo = res.data;
        }
      });
  }

  updateMediaPack() {
    console.log('[PACK DOWNLOAD]: In Func Update Media Pack');
    this.dataPackUpdate = 'downloading-media';
    return this.nis.contentPack
      .updatePack$(this.mediaList[0].mediaId, this.mediaList[0].packId)
      .then((res) => {
        if (res.data) {
          console.log('[PACK DOWNLOAD]: Response updatePack$ Media Success');
          console.log(res);
          this.downloadInfo = res.data;
        }
      });
  }

  abortMediaDownload(): void {
    if (this.downloadInfo) {
      this.nis.contentPack.cancelDownload$(this.downloadInfo).then((r) => {
        console.log('[PACK DOWNLOAD]: download aborted');
        console.log('[PACK DOWNLOAD]: Init online mode');
        this.initData('online');
      });
    }
  }

  abortDownloads(): void {
    if (this.downloadInfo) {
      this.nis.contentPack.cancelDownload$(this.downloadInfo).then((r) => {
        console.log('[PACK DOWNLOAD]: download aborted');
      });
    }
  }

  ngOnDestroy(): void {
    // this.abortDownloads();
    this.subscriptions.unsubscribe();
    // this.abortMediaDownload();
  }
}
